<ng-template #detail let-processId>
   <span class="eb-detail-label">Process ID</span>
   <span class="eb-detail-value">{{ processId }}</span>
   <button type="button" class="eb-copy" (click)="copy( processId )" [attr.aria-label]="'Copy process ID ' + processId">
      {{ copiedId === processId ? 'Copied' : 'Copy' }}
   </button>
</ng-template>

<ng-template #stamp let-stamp>
   {{ stamp.stamp }} <strong class="eb-tz">{{ stamp.tz }}</strong>
</ng-template>

<div class="eb" role="region" aria-label="Messages" *ngIf="view$ | async as view">

   <!-- summary bar (always visible) -->
   <div class="eb-bar {{ view.type }}">
      <div class="eb-bar-main">
         <span class="eb-bar-icon">
            <mat-icon class="eb-icon-20" [svgIcon]="typeIcons[view.type]" aria-hidden="true"></mat-icon>
         </span>

         <div class="eb-chips eb-desktop">
            <button type="button" class="eb-chip {{ group.type }}" *ngFor="let group of view.groups"
               [title]="'Show ' + (group.title | lowercase)" (click)="view.total > 1 && showGroup( group.type )">
               <span class="eb-dot"></span>{{ group.label }}
            </button>
         </div>

         <div class="eb-headline" aria-live="polite">
            <div>{{ view.headline }}</div>
            <time class="eb-stamp eb-bar-stamp-mobile eb-mobile" *ngIf="view.stamp" [attr.title]="view.stamp.tzName">
               <ng-container *ngTemplateOutlet="stamp; context: { $implicit: view.stamp }"></ng-container>
            </time>
            <div class="eb-detail eb-bar-detail" *ngIf="view.processId">
               <ng-container *ngTemplateOutlet="detail; context: { $implicit: view.processId }"></ng-container>
            </div>
         </div>

         <time class="eb-stamp eb-bar-stamp eb-desktop" *ngIf="view.stamp" [attr.title]="view.stamp.tzName">
            <ng-container *ngTemplateOutlet="stamp; context: { $implicit: view.stamp }"></ng-container>
         </time>

         <button type="button" class="eb-toggle eb-desktop" *ngIf="view.total > 1"
            [attr.aria-expanded]="expanded" (click)="toggle()">
            {{ expanded ? 'Hide messages' : 'Show ' + view.total + ' messages' }}
            <mat-icon class="eb-icon-14 eb-chevron" [class.open]="expanded" svgIcon="chevron_down" aria-hidden="true"></mat-icon>
         </button>

         <button type="button" class="eb-dismiss-all" (click)="clearAll()"
            [title]="view.total > 1 ? 'Dismiss all ' + view.total + ' messages' : 'Dismiss'"
            aria-label="Dismiss all messages">
            <mat-icon class="eb-icon-18" svgIcon="close" aria-hidden="true"></mat-icon>
         </button>
      </div>

      <!-- mobile: chips + toggle on their own row -->
      <button type="button" class="eb-toggle-row eb-mobile" *ngIf="view.total > 1"
         [attr.aria-expanded]="expanded" (click)="toggle()">
         <span class="eb-chips">
            <span class="eb-chip {{ group.type }}" *ngFor="let group of view.groups">
               <span class="eb-dot"></span>{{ group.label }}
            </span>
         </span>
         <span class="eb-toggle-label">
            {{ expanded ? 'Hide' : 'Show all' }}
            <mat-icon class="eb-icon-16 eb-chevron" [class.open]="expanded" svgIcon="chevron_down" aria-hidden="true"></mat-icon>
         </span>
      </button>
   </div>

   <!-- expanded list -->
   <div class="eb-list" #list *ngIf="expanded && view.total > 1">
      <div class="eb-group {{ group.type }}" *ngFor="let group of view.groups" [attr.data-group]="group.type">
         <div class="eb-group-head">
            <button type="button" class="eb-group-toggle" (click)="toggleGroup( group.type )"
               [attr.aria-expanded]="!collapsedGroups.has( group.type )" [attr.aria-controls]="'eb-group-' + group.type"
               [title]="(collapsedGroups.has( group.type ) ? 'Show ' : 'Hide ') + (group.title | lowercase)">
               <mat-icon class="eb-icon-14 eb-group-chevron" [class.collapsed]="collapsedGroups.has( group.type )"
                  svgIcon="chevron_down" aria-hidden="true"></mat-icon>
               <span class="eb-group-icon">
                  <mat-icon class="eb-icon-14" [svgIcon]="typeIcons[group.type]" aria-hidden="true"></mat-icon>
               </span>
               <span class="eb-group-title">{{ group.title }}</span>
               <span class="eb-group-count">· {{ group.messages.length }}</span>
            </button>
            <button type="button" class="eb-group-dismiss" *ngIf="group.messages.length > 1" (click)="clearType( group.type )">
               <span class="eb-desktop">{{ group.dismissLabel }}</span>
               <span class="eb-mobile">Dismiss all</span>
            </button>
         </div>

         <div class="eb-group-items" [id]="'eb-group-' + group.type" *ngIf="!collapsedGroups.has( group.type )">
            <div class="eb-item" *ngFor="let message of group.messages; trackBy: trackById">
               <span class="eb-item-dot"></span>
               <div class="eb-item-body">
                  <div class="eb-item-text">{{ message.text }}</div>
                  <time class="eb-stamp eb-item-stamp-mobile eb-mobile" *ngIf="message.stamp" [attr.title]="message.tzName">
                     <mat-icon class="eb-icon-12" svgIcon="clock" aria-hidden="true"></mat-icon>
                     <span>{{ message.stamp }}</span>
                     <strong class="eb-tz">{{ message.tz }}</strong>
                  </time>
                  <div class="eb-detail eb-item-detail" *ngIf="message.processId">
                     <ng-container *ngTemplateOutlet="detail; context: { $implicit: message.processId }"></ng-container>
                  </div>
               </div>
               <time class="eb-stamp eb-item-stamp eb-desktop" *ngIf="message.stamp" [attr.title]="message.tzName">
                  <ng-container *ngTemplateOutlet="stamp; context: { $implicit: message }"></ng-container>
               </time>
               <button type="button" class="eb-item-dismiss" aria-label="Dismiss" (click)="errors.clear( message.id )">
                  <mat-icon class="eb-icon-16" svgIcon="close" aria-hidden="true"></mat-icon>
               </button>
            </div>
         </div>
      </div>
   </div>
</div>
